/**
 * Regras puras do modo VSL — sem DOM, para rodar no player, no editor e nos
 * testes.
 */

/**
 * Progresso ilustrativo. `t` é a fração real assistida (0..1); `curve` é a
 * intensidade: 1 = linear, acima disso a barra corre no início e freia no fim.
 *
 *   curve 2:  25% real → 44% na barra · 50% → 75% · 75% → 94%
 */
export function fakeProgressRatio(t: number, curve: number): number {
  const real = Math.min(1, Math.max(0, Number.isFinite(t) ? t : 0));
  const k = Math.min(6, Math.max(1, Number.isFinite(curve) ? curve : 1));
  return 1 - Math.pow(1 - real, k);
}

/**
 * Pontos de início dos trechos exibidos na prévia, espalhados pelo vídeo.
 * Evita o comecinho (costuma ser logo) e o final (revelaria a oferta).
 */
export function previewSegmentStarts(durationSec: number, count: number, segmentSec: number): number[] {
  if (!Number.isFinite(durationSec) || durationSec <= 0) return [0];
  const n = Math.min(8, Math.max(1, Math.round(count)));
  const seg = Math.max(1, segmentSec);
  // Vídeo curto demais para alternar: prévia vira um loop do início.
  if (durationSec <= seg * 2) return [0];

  const usable = durationSec * 0.85; // ignora os últimos 15%
  const starts: number[] = [];
  for (let i = 0; i < n; i++) {
    const center = ((i + 0.5) / n) * usable;
    const start = Math.max(0, Math.min(durationSec - seg, center - seg / 2));
    starts.push(Number(start.toFixed(2)));
  }
  return starts;
}

/** Limita um valor numérico vindo de configuração. */
export function bounded(value: unknown, min: number, max: number, fallback: number): number {
  const n = typeof value === 'string' ? Number(value) : value;
  if (typeof n !== 'number' || !Number.isFinite(n)) return fallback;
  return Math.min(max, Math.max(min, n));
}

/** Texto de overlay: sem HTML, tamanho limitado. */
export function boundedText(value: unknown, max: number, fallback: string): string {
  if (typeof value !== 'string') return fallback;
  const cleaned = value.replace(/[<>]/g, '').trim().slice(0, max);
  return cleaned || fallback;
}

const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;
const RGBA = /^rgba?\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*(,\s*(0|1|0?\.\d+)\s*)?\)$/i;

/** Aceita só cores que não podem carregar CSS malicioso. */
export function safeCssColor(value: unknown, fallback: string): string {
  if (typeof value !== 'string') return fallback;
  const v = value.trim();
  return HEX.test(v) || RGBA.test(v) ? v : fallback;
}
